<!--
Event manager

Uses an API from the event manager plugin to get event or instance availability & eligibility

Works in three steps:
	1) Go to the vue store and request the availability data
		- this done in the vue store so if another component has already requested the data, we dont have to make another api call
	2) Use that data to calculate availability & eligibility, and set them as strings
	3) When both functions are done, we can run any other function
		- in boiler this sets the button text/state/url
		- this is set in a watch function
-->
<template>
	<div>
		<slot
			:button="button"
			:onSale="onSale"
			:availability="availability"
			:eligibility="eligibility"
		>
		</slot>
	</div>
</template>
<script>
	import axios from "axios";

	export default {
		name: "event-manager",

		data: function () {
			return {
				loading: true,
				availability: "",
				availabilityChecked: false,
				showAvailabilityInfo: true,
				eligibility: "",
				eligibilityChecked: false,
				error: "",
				currentDateTime: null,
				apiEventData: null,
				button: {
					text: this.$props.buttonData.buttonDefaultText,
					class: "",
					disabled: false,
					href: this.addParams(this.$props.buttonData.buttonDefaultUrl),
				},
				onSale: false,
			};
		},
		computed: {
			apiReturn() {
				return this.availabilityChecked && this.eligibilityChecked;
			},
			storeEventData() {
				if (this.mode == "entry") {
					return this.$store.state.eventData;
				} else {
					return this.apiEventData;
				}
			},
		},
		props: {
			type: {
				type: String,
			},
			mode: {
				type: String,
				default: "index",
			},
			instanceData: {
				type: Object,
			},
			eventData: {
				type: Object,
			},
			tnewData: {
				type: Object,
			},
			availabilityData: {
				type: Object,
			},
			buttonData: {
				type: Object,
			},
			params: {
				type: Array,
			}
		},

		mounted() {
			const self = this;

			if (!this.instanceData.stopSellingDate) {
				this.onSale = true;
			}

			axios.get("/datetime.php", {}).then((datetimeresponse) => {
				if (datetimeresponse.status == 200) {
					self.currentDateTime = Date.parse(datetimeresponse.data);

					if (this.instanceData.stopSellingDate) {
						let stopSellingDate = Date.parse(this.instanceData.stopSellingDate);

						this.onSale =
							!stopSellingDate || stopSellingDate > self.currentDateTime;
					}

					if (this.mode == "entry") {
						self.$store.dispatch("getEventData", {
							id: self.eventData.eventId,
						});
					} else {
						axios
							.get(
								"/actions/event-manager/availability/event?id=" +
									self.eventData.eventId
							)
							.then((response) => {
								self.apiEventData = response.data;
							})
							.catch((error) => {
								return "Event id not found";
							});
					}
				}
			});
		},

		methods: {
			addParams(url) {
				const queryString = window.location.search;
				const urlParams = new URLSearchParams(queryString);
				let newUrl = new URL(url);

				for (const item of this.params) {
					const param = urlParams.get(item);

					if(param) {
						newUrl.searchParams.set(item, param);
					}
				}

				return newUrl;
			},
			getAvailability() {
				const self = this;

				// Check to see if overrides have been set
				if (self.availabilityData.availabilityOverride != "syncValue") {
					//console.log("getInstanceAvailability - overriden");
					self.availability = self.availabilityData.availabilityOverride;
				}
				//check to see if manual instance
				else if (!self.tnewData.instanceId) {
					//console.log("getInstanceAvailability - manual instance");
					self.availability = "Available";
				} else {
					if (self.type == "event" && self.eventData.numberOfInstances > 1) {
						const eventAvailabilty = self.storeEventData.availability.stats;

						if (eventAvailabilty.instances_bookable == 0) {
							self.availability = "Sold Out";
						} else {
							self.availability = "Available";
						}
					} else {
						let instance = self.storeEventData.availability.instances.find(
							(o) => o.id == self.instanceData.instanceId
						);
						const availabilityData = instance.availability;

						// named predicates of availability
						const isLow =
							availabilityData.available < availabilityData.capacity / 10;
						const isLimited =
							availabilityData.available < availabilityData.capacity / 20;
						const isSoldOut =
							(availabilityData.available ?  availabilityData.available : 0) < 1;

						if (isSoldOut) {
							// axios.get(lockSeatsUrl  , {
							//   //crossdomain: true,
							// }).then((response) => {
							//   const lockData = response.data;
							//   if (lockData.dDeafBslUser || lockData.generalAccessMember || lockData.generalAccessMember|| lockData.wheelchairUser || lockData.prologueLockCount > 0) {
							//     self.availability = 'Access Availability';
							//   }
							//   else {
							//     self.availability = 'Sold Out';
							//   }
							// });

							self.availability = "Sold Out";
						} else if (isLow) {
							self.availability = "Low Availability";
						} else if (isLimited) {
							self.availability = "Selling Fast";
						} else {
							self.availability = "Available";
						}
					}
				}
				self.availabilityChecked = true;
			},
			getEligibility() {
				var self = this;
				const onSaleScheduleData = self.storeEventData.onSaleSchedules;

				var currentOnSaleSchedule;
				var mostRecentPastRow;

				if (onSaleScheduleData.length) {
					// Parse out the current on sale schedule value
					for (var i = 0; i < onSaleScheduleData.length; i++) {
						var onSaleScheduleDate = Date.parse(onSaleScheduleData[i].date);
						if (onSaleScheduleDate > self.currentDateTime) {
							if (i !== 0 && !currentOnSaleSchedule) {
								currentOnSaleSchedule = onSaleScheduleData[i - 1];
							}
						} else {
							mostRecentPastRow = onSaleScheduleData[i];
						}
					}

					if (!currentOnSaleSchedule && mostRecentPastRow) {
						currentOnSaleSchedule = mostRecentPastRow;
					}
					//console.log(
					//	onSaleScheduleData,
					//	currentOnSaleSchedule,
					//	mostRecentPastRow
					//);

					if (currentOnSaleSchedule) {
						// Update values based on OSS value
						if (currentOnSaleSchedule.status === "public") {
							self.eligibility = "Public";
						} else if (currentOnSaleSchedule.status === "members") {
							self.eligibility = "Members Only";
						} else if (currentOnSaleSchedule.status === "comingSoon") {
							self.eligibility = "Coming Soon";
						} else if (currentOnSaleSchedule.status === "notOnSale") {
							self.eligibility = "Not On Sale";
							console.error(
								"Non-visible on sale schedule as current in availability api response"
							);
						} else {
							console.error(
								"Unknown status schedule value in availability api response"
							);
						}
					} else {
						// No past rows logic here
						// Shouldn't ever get here, as no past rows events are hidden, so console error
						console.error(
							"reached no past rows on sale schedule logic in availability, when event should be hidden"
						);
					}
				}
				self.eligibilityChecked = true;
			},
			setButtonAttributes() {
				const self = this;

				//We run this from low override priority to high - constantly checking for override data is annoying otherwise
				//console.log(self.eligibility, self.availability, self.buttonData);
				//if E = public
				if (self.eligibility == "Public") {
					//if A = Available
					if (self.availability == "Available") {
						self.button.text = "Book now";
						self.button.href = this.addParams(self.button.href);
					}
					//if A = Low availability
					if (self.availability == "Low Availability") {
						self.button.text = "Book now";
						self.button.href = this.addParams(self.button.href);
					}
					//if A = Selling fast
					if (self.availability == "Selling Fast") {
						self.button.text = "Book now";
						self.button.href = this.addParams(self.button.href);
					}
				}
				//if E = members
				else if (self.eligibility == "Members Only") {
					self.button.text = "Members Only";
					self.button.href = this.addParams(self.button.href);
				}
				//if E = coming soon
				else if (self.eligibility == "Coming Soon") {
					self.button.text = "Coming soon";
					self.button.href = "#";
					self.button.disabled = true;
					self.button.class = self.button.class + " o-button--disabled";
					self.showAvailabilityInfo = false;
				}

				//if A = sold out
				if (self.availability == "Sold Out") {
					self.button.text = "Sold Out";
					self.button.href = "#";
					self.button.disabled = true;
					self.button.class = self.button.class + " o-button--disabled";
				}

				//if A = Access availability
				if (self.availability == "Access Availability") {
					self.button.text = "Limited Availability";
					self.button.href = this.addParams(self.button.href);
				}

				if (self.availability == "Cancelled") {
					self.button.text = "Cancelled";
					self.button.href = "#";
					self.button.disabled = true;
					self.button.class = self.button.class + " o-button--disabled";
					self.showAvailabilityInfo = false;
				}

				switch (self.buttonData.buttonPreset) {
					case "Hide button":
						self.button.class = "o-button--hidden";
						break;

					case "Sold out":
						self.button.text = "Sold out";
						self.button.href = "#";
						self.button.disabled = true;
						self.button.class = self.button.class + " o-button--disabled";
						break;

					case "Coming soon":
						self.button.text = "Coming soon";
						self.button.href = "#";
						self.button.disabled = true;
						self.button.class = self.button.class + " o-button--disabled";
						break;

					case "Postponed":
						self.button.text = "Postponed";
						self.button.href = "#";
						self.button.disabled = true;
						self.button.class = self.button.class + " o-button--disabled";
						break;

					case "Cancelled":
						self.button.text = "Cancelled";
						self.button.href = "#";
						self.button.disabled = true;
						self.button.class = self.button.class + " o-button--disabled";
						break;

					case "Access only":
						self.button.text = "Access only";
						self.button.href = this.addParams(self.$props.buttonData.buttonDefaultUrl);
						self.button.href = this.addParams(self.button.href);
						self.button.disabled = false;
						self.button.class = self.button.class.replace(
							" o-button--disabled",
							""
						);
						break;

					case "Custom":
						self.button.text = self.buttonData.buttonTextOverride
							? self.buttonData.buttonTextOverride
							: self.button.text;
						self.button.href = self.buttonData.buttonHrefOverride
							? self.buttonData.buttonHrefOverride
							: self.button.href;
						self.button.href = this.addParams(self.button.href)
						if (
							self.buttonData.buttonStateOverride == "disabled" ||
							self.buttonData.buttonStateOverride == "enabled"
						) {
							self.button.disabled =
								self.buttonData.buttonStateOverride == "enabled" ? false : true;
							self.button.class =
								self.buttonData.buttonStateOverride == "enabled"
									? self.button.class.replace("o-button--disabled", "")
									: self.button.class + " o-button--disabled";
						} else if (self.buttonData.buttonStateOverride == "hidden") {
							self.button.class = "o-button--hidden";
						}
						break;
				}
			},
		},
		watch: {
			apiReturn(value) {
				if (value) {
					this.setButtonAttributes();
				}
			},
			storeEventData(newVal, oldVal) {
				var self = this;

				self.getAvailability();
				self.getEligibility();
			},
		},
	};
</script>
